function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext, useId } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { Body, CallToAction, Heading, Label } from "../../atoms";
import { useAccentColors } from "../../hooks";
import { Tag } from "../Tag";
import { LightArrowRight } from "../../visuals";
import ReactConfigContext from "../../ReactConfigContext";
export default function InfoCard(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "default" : _param_variant, label = param.label, title = param.title, action = param.action, description = param.description, metadata = param.metadata, tags = param.tags, callToActions = param.callToActions, accentColor = param.accentColor, style = param.style, className = param.className;
    var id = useId();
    var accentStyle = useAccentColors([
        "colors-info-card-accent",
        accentColor
    ]);
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement("article", {
        style: _object_spread({}, style, accentStyle),
        className: twMerge("flex", className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("w-full rounded-xl bg-bg-subtle", variant === "default" && "p-6 md:p-8", variant === "tight" && "p-6")
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid grid-cols-1 grid-flow-row auto-rows-max", variant === "default" && "gap-6", variant === "tight" && "gap-5")
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge("grid grid-cols-1 grid-flow-row auto-rows-max", variant === "default" && "gap-6", variant === "tight" && "gap-3", action.className)
    }), !!label && /*#__PURE__*/ React.createElement(Label, {
        className: "text-info-card-accent"
    }, label), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: variant === "tight" ? "h4" : "h3"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description), (metadata === null || metadata === void 0 ? void 0 : metadata.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-3"
    }, metadata.map(function(entry) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "entry-".concat(id, "-").concat(entry.label),
            className: "grid items-center gap-5 grid-cols-[auto_1fr]"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "text-info-card-accent"
        }, entry.icon), /*#__PURE__*/ React.createElement(Body, null, entry.label));
    }))), !!(tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-start flex-wrap -m-2"
    }, tags.map(function(tag) {
        return /*#__PURE__*/ React.createElement(Tag, _object_spread_props(_object_spread({}, tag), {
            key: "tag-".concat(id, "-").concat(tag.href),
            accentColor: accentColor,
            className: "m-2"
        }), tag.label);
    }))), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-start flex-wrap -m-2"
    }, callToActions.map(function(cta) {
        return /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, cta), {
            key: "cta-".concat(id, "-").concat(cta.href),
            buttonType: "icon-after",
            variant: "button/link",
            icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
            className: "m-2"
        }));
    }))))));
}

//# sourceMappingURL=InfoCard.js.map